import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <footer className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white py-16 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-600/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-700/20 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Large Logo on Left */}
          <div className="flex flex-col items-start">
            <img
              src="https://customer-assets.emergentagent.com/job_8a8efe14-e280-43f8-81be-49615652987c/artifacts/9yt2jtjq_Logo%20Weiss%20Transparent.png"
              alt="Vivalo Logo"
              className="h-32 md:h-40 lg:h-52 w-auto drop-shadow-2xl transform transition-all duration-300 hover:scale-105 mb-6"
            />
            <p className="text-blue-100">
              Ihr moderner Versicherungsbroker in der Schweiz - mit jahrelanger Expertise und persönlichem Service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Schnelllinks</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Leistungen
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('partners')}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Partner
                </button>
              </li>
              <li>
                <button
                  onClick={() => { navigate('/about'); window.scrollTo(0, 0); }}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Über uns
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Kontakt
                </button>
              </li>
              <li>
                <button
                  onClick={() => { navigate('/impressum'); window.scrollTo(0, 0); }}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Impressum
                </button>
              </li>
              <li>
                <button
                  onClick={() => { navigate('/datenschutz'); window.scrollTo(0, 0); }}
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Datenschutz
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-2 text-blue-200">
              <li>
                <p className="font-semibold text-white mb-1">Vivalo GmbH</p>
              </li>
              <li>Chaltenbodenstrasse 26</li>
              <li>8834 Schindellegi</li>
              <li>Schweiz</li>
              <li className="pt-2">
                <a href="tel:+41416776767" className="hover:text-white transition-colors">
                  041 677 67 67
                </a>
              </li>
              <li>
                <a href="mailto:info@vivalo.ch" className="hover:text-white transition-colors">
                  info@vivalo.ch
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-blue-700/50 pt-8 text-center text-blue-200">
          <p>© {currentYear} Vivalo GmbH. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;